import { object, string, number } from "yup";

export const NewAreaSchema = object({
  name: string().required("Задолжително"),
  polygonData: string().required("Задолжително"),
  cityFK: number().typeError("Невалидно").required("Задолжително"),
  color: string().optional(),
});
